import React, { useEffect, useState } from 'react'
import GeofenceTable from './components/GeofencesTable'
import GeofencesVehicles from './components/GeofencesVehicles'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../Layout/Loader'
import { resetCatFilters, resetFilters } from '../../Actions/Devices'

const GeofencesDashboard = () => {
    const [showVehicles, setIsShowVehicles] = useState(false)
    const [selectedCatergoryName, setSelectedGeofenceCategory] = useState("")
    const [selectedGeofenceName, setSelectedGeofenceName] = useState("")
    const allInsideGeofences = useSelector((state) => state.insideGeofence);


    const hideGeofencesTable = (value) => {
        if (value) {
            if (value.geofenceName && value.category) {
                setSelectedGeofenceName(value.geofenceName)
                setSelectedGeofenceCategory(value.category)
            }
        }
        setIsShowVehicles(true)
    }
    const hideGeofencesVehicle = () => {
        setIsShowVehicles(false)
    }
const dispatch=useDispatch()
     useEffect(() => {
        return () => {
          dispatch(resetFilters());
          dispatch(resetCatFilters());
        };
      }, [dispatch]);
    return (
        <>
            {Object.keys(allInsideGeofences)?.length > 0 ? <>
                {
                    showVehicles ?
                        <GeofencesVehicles
                            hideGeofencesVehicle={hideGeofencesVehicle}
                            selectedCatergoryName={selectedCatergoryName}
                            selectedGeofenceName={selectedGeofenceName}
                        /> :
                        <GeofenceTable hideGeofencesTable={hideGeofencesTable} />
                }
            </> : <Loader />}
        </>
    )
}

export default GeofencesDashboard